@if (!preLoading) {
  <div class="modal-body rounded text-center" style="overflow: visible;">
    <h4>Are you sure?</h4>

    @if(userHasAssignments) {
      <p>The user selected for deletion has jobs assigned to them.</p>
      <p><strong>Select the new owner</strong>:</p>
      <p-dropdown
        [options]="accountants"
        [(ngModel)]="selectedNewOwner"
        (onChange)="startCountdown()"
        optionLabel="user.full_name"
        showClear="true"
        placeholder="Select...">
      </p-dropdown>
      <div class="row">
        <div class="col-12">
          <input type="checkbox" [disabled]="true" checked="true"> Also set this user as the owner of Repeated Jobs
        </div>
      </div>
    }

    @else {
      <p>Do you really want to remove this staff member?</p>
    }

    <div class="row">
      <div class="col-6">
        <button type="button" class="btn btn-default pull-right btn-block" (click)="cancel()">
          Cancel
        </button>
      </div>
      <div class="col-6">
        <button type="button"
            [disabled]="userHasAssignments && !selectedNewOwner || inCountdown || loading"
            class="btn btn-danger pull-left btn-block"
            style="display: flex; align-items: center; justify-content: center; gap: 4px"
            (click)="confirm()">
          @if (inCountdown) {
            <span tooltip="Please wait the timer to confirm the removal">Wait {{ countdown }} second{{ countdown > 1 ? 's' : null }}</span>
          }
          @else {
            @if (userHasAssignments) {
              <span>Reassign and Remove</span>
            }
            @else {
              <span>Remove</span>
            }
          }
          @if (loading) {
            <i class="fa fa-spinner fa-spin"></i>
          }
        </button>
      </div>
    </div>
  </div>
}
@else {
  <div class="loading"><i class="fa fa-spinner fa-spin"></i></div>
}
